export const MatchLiveStatusMap = (data) => {
    console.log('here data', data)
    if (data.status) {
        let message = "TBD"
        if (data.status == "live") { message = <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
            <span
                style={{
                display: "inline-block",
                width: 8,
                height: 8,
                borderRadius: "50%",
                backgroundColor: "#00c446",
                }}
            />
            Live
            </span> }
        if (data.status == "walk over") { message = "Walk over" }
        if (data.status == "completed" || data.status == "end") { 
            if (data.isWO) { message = "Walkover" }
            else { message = "Completed" }
        }
        if (data.status == "not before") { message = `Not before ${data.date || ''} ${data.hour || ''}`}
        return message
    } else return "TBD"
}